var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiIconNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h31a1 1 0 011 1v13a4 4 0 01-4 4H1a1 1 0 01-1-1V4z",
    fill: "#FE5B4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.864 4.432h1.032l4.848 6.972h.036V4.432h.984V13h-1.008L5.884 5.956h-.036V13h-.984V4.432zm8.625 0h6.072v.852h-5.088v2.868h4.8v.852h-4.8v3.144h5.292V13h-6.276V4.432zm6.837 0h1.104l1.884 7.188h.048l1.956-7.188h1.068l1.944 7.188h.048l1.884-7.188h1.104L28.906 13h-1.092L25.87 5.86h-.036L23.878 13h-1.092l-2.46-8.568z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/AiIconNew.af145262.svg";
export { SvgAiIconNew as ReactComponent };